import { jsx as _jsx } from "react/jsx-runtime";
import { ObjectTree } from '../../../v2/components/generic/ObjectTree';
import { NavigationSkeleton } from '../../common/NavigationSkeleton';
import { getMetaModelDerivedPaths } from '../../EnititySupport/MetamodelTree/getMetamodelDerivedPath';
export const TreeObjectsAssociations = ({ applicationData, contextCustomer }) => {
    if (!contextCustomer)
        return _jsx(NavigationSkeleton, {}, 'treeObjectsAssociations');
    return (_jsx(ObjectTree, { contextObjects: [contextCustomer],
        hideTopStep: true,
        nodeEdgeMapper: applicationData,
        queryPaths: getMetaModelDerivedPaths({ treeNode: contextCustomer }),
        queryLimit: 10,
        maxVisibleNodes: 10 }, 'treeObjectsAssociations'));
};
